module.exports = __webpack_public_path__ + "img/图片11.a1ac7e65.png";